import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import _ from 'lodash';
import * as api from '../../../api';
import Button from '../../../components/bootstrap/Button';
import Card, {
	CardBody,
	CardHeader,
	CardLabel,
	CardTitle,
} from '../../../components/bootstrap/Card';
import Page from '../../../layout/Page/Page';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import { setAlert, setLoading, setUnitPreviewPage } from '../../../globalState/action-creators';
import './media.css';
import 'antd/dist/antd.css';
import { allowedVehiclesUnits, USER_ROLE, durationType } from '../../../constants';
import Select from '../../../components/bootstrap/forms/Select';

const AddUnit = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const user = useSelector((state) => state?.user);

	const token = sessionStorage.getItem('token');
	useEffect(() => {
		if (!token) {
			navigate('/auth-pages/login', { replace: true });
			return;
		}

		if (user?.role === USER_ROLE.SUPER_ADMIN) {
			fetchAllPartnerNames();
		}
		// eslint-disable-next-line
	}, []);
	const [partnerData, setPartnerData] = useState([]);

	const [unitNumberError, setUnitNumberError] = useState(false);
	const [residentAllowedVehiclesError, setResidentAllowedVehiclesError] = useState(false);
	const [guestAllowedVehicleError, setGuestAllowedVehicleError] = useState(false);
	const [guestAccessDurationError, setGuestAccessDurationError] = useState(false);
	const [partnerNameError, setPartnerNameError] = useState(false);

	const fetchAllPartnerNames = async () => {
		try {
			const { data } = await api.getAllPartnerNames();
			if (data?.success) {
				const partnerData = data.data.map((item) => {
					return {
						...item,
						value: item?.partnerName,
						text: item?.partnerName,
					};
				});
				setPartnerData(partnerData);
			}
		} catch (error) {
			console.log(error);
		}
	};

	const [formData, setFormData] = useState({
		unitNumber: '',
		residentAllowedVehicles: '',
		partnerEmail: '',
		partnerName: '',
		guestAllowedVehicles: '',
		guestAccessDuration: '',
		guestAccessDurationType: 'Minutes',
		zone: '',
	});

	const onChange = (e) => {
		const { name, value } = e.target;
		if (name === 'unitNumber') {
			setUnitNumberError(false);
		}

		if (name === 'residentAllowedVehicles') {
			setResidentAllowedVehiclesError(false);
		}
		if (name === 'guestAllowedVehicles') {
			setGuestAllowedVehicleError(false);
		}
		if (name === 'guestAccessDuration') {
			setGuestAccessDurationError(false);
		}
		if (name === 'partnerName') {
			setPartnerNameError(false);
		}

		const maxValues = {
			Minutes: 59,
			Hours: 24,
		};

		if (name === 'guestAccessDurationType' || name === 'guestAccessDuration') {
			const currentType =
				name === 'guestAccessDurationType' ? value : formData.guestAccessDurationType;
			const currentDuration =
				name === 'guestAccessDuration'
					? parseInt(value)
					: parseInt(formData.guestAccessDuration);

			if (currentDuration > maxValues[currentType]) {
				setFormData({
					...formData,
					guestAccessDuration: maxValues[currentType].toString(),
					guestAccessDurationType: currentType,
				});
			} else {
				setFormData({
					...formData,
					[name]: name === 'guestAccessDuration' ? value : value,
				});
			}
		} else {
			setFormData({
				...formData,
				[name]: value,
			});
		}

		// 	console.log('value', value);
		// 	if (value === 'Minutes' && parseInt(formData?.guestAccessDuration) > 59) {
		// 		console.log('Minutes', value);

		// 		setFormData({
		// 			...formData,
		// 			guestAccessDuration: '59',
		// 			guestAccessDurationType: 'Minutes',
		// 		});
		// 	} else if (value === 'Hours' && parseInt(formData?.guestAccessDuration) > 24) {
		// 		setFormData({
		// 			...formData,
		// 			guestAccessDuration: '24',
		// 			guestAccessDurationType: 'Hours',
		// 		});
		// 	}else{
		// 		setFormData({
		// 			...formData,
		// 			guestAccessDurationType: value,
		// 		});}
		// }else if(name ==="guestAccessDuration"){
		// 	if (formData?.guestAccessDurationType === 'Minutes' && parseInt(value) > 59) {
		// 		console.log('Minutes', value);

		// 		setFormData({
		// 			...formData,
		// 			guestAccessDuration: '59',
		// 			guestAccessDurationType: 'Minutes',
		// 		});
		// 	} else if (formData?.guestAccessDurationType === 'Hours' && parseInt(value) > 24) {
		// 		setFormData({
		// 			...formData,
		// 			guestAccessDuration: '24',
		// 			guestAccessDurationType: 'Hours',
		// 		});
		// 	}else{
		// 		setFormData({
		// 			...formData,
		// 			guestAccessDuration: value,
		// 		});
		// 	}
		// } else {
		// 	setFormData({
		// 		...formData,
		// 		[name]: value,
		// 	});
		// }

		// formik.handleChange(e);
	};

	const createUnit = async () => {
		dispatch(setLoading(true));
		try {
			let error;
			const reDigit = /^[0-9]*$/;
			if (_.get(formData, 'unitNumber', '')?.length <= 0) {
				error = true;
				setUnitNumberError(true);
			}
			if (_.get(formData, 'residentAllowedVehicles', '')?.length <= 0) {
				error = true;
				setResidentAllowedVehiclesError(true);
			}
			if (_.get(formData, 'guestAllowedVehicles', '')?.length <= 0) {
				error = true;
				setGuestAllowedVehicleError(true);
			}
			if (_.get(formData, 'guestAccessDuration', '')?.length <= 0) {
				error = true;
				setGuestAccessDurationError(true);
			}

			if (
				user?.role === USER_ROLE.SUPER_ADMIN &&
				_.get(formData, 'partnerName', '')?.length <= 0
			) {
				error = true;
				setPartnerNameError(true);
			}
			if (!error) {
				// if (!formData?.residentAllowedVehicles) {
				// 	delete formData?.residentAllowedVehicles;
				// }
				const { data } = await api.addUnit(formData);
				if (data.success) {
					dispatch(setUnitPreviewPage({ unitPage: 1 }));
					navigate('/Unit');
					dispatch(setAlert(data.message, 'Success'));
				} else {
					dispatch(setAlert(data.message, 'Error'));
				}
			}
		} catch (error) {
			dispatch(setAlert(error.message, 'Error'));
		}
		dispatch(setLoading(false));
	};

	return (
		<PageWrapper title='Add Unit'>
			<Page container='fluid'>
				<div className='row'>
					<div className='col-xxl-6'>
						<Card stretch>
							<CardHeader>
								<CardLabel icon='Plus' iconColor='dark'>
									<CardTitle tag='h4' className='h5'>
										Create Unit
									</CardTitle>
								</CardLabel>
							</CardHeader>
							<CardBody>
								<div className='row'>
									<div className='create_vehicle_inner'>
										<div className='mx-2'>
											<p>
												<strong className='create-vehicle-heading'>
													Unit Features
												</strong>
											</p>
										</div>
										<div className='create-vehicle-wrapper add_vehicle'>
											<div className='card-info-item card-inner'>
												<div className='label'>
													<p className='mx-3 lable_spacing'>
														Unit Number{' '}
														<span className='text-danger fw-bold'>
															*
														</span>
													</p>
												</div>
												<div className='data'>
													<input
														type='text'
														id='unitName'
														className='form-control addVehicleSelect no-arrows'
														autoComplete='off'
														onChange={(e) => {
															onChange(e);
														}}
														name='unitNumber'
														style={styles.inputStyles}
													/>
												</div>
												<span
													id='unitNumber'
													className='text-danger danger-msg'
												>
													{unitNumberError && 'Please Enter Unit Number!'}
												</span>
											</div>

											{user?.role === USER_ROLE.SUPER_ADMIN && (
												<div className='card-info-item card-inner'>
													<div className='label'>
														<p className='mx-3 lable_spacing'>
															Partner Name{' '}
															<span className='text-danger fw-bold'>
																*
															</span>
														</p>
													</div>
													<div className='data'>
														<Select
															ariaLabel='Default select example'
															placeholder=' '
															id='partnerName'
															name='partnerName'
															value={formData?.partnerName}
															onChange={(e) => {
																onChange(e);
																const selectedValue =
																	e.target.value;
																const selectedItem =
																	partnerData.find(
																		(item) =>
																			item.value ===
																			selectedValue,
																	);
																setFormData((prevFormData) => ({
																	...prevFormData,
																	partnerEmail:
																		selectedItem?.email || '',
																}));
															}}
															list={partnerData}
															className='addVehicleSelect inputBoxShadow'
														/>
													</div>
													<span className='text-danger danger-msg'>
														{partnerNameError
															? 'Partner required!'
															: ''}
													</span>
												</div>
											)}

											<div className='card-info-item card-inner'>
												<div className='label'>
													<p className='mx-3 lable_spacing'>
														# of Resident Spaces Allowed{' '}
														<span className='text-danger'>*</span>
													</p>
												</div>
												<div className='data'>
													<Select
														ariaLabel='Default select example'
														placeholder=' '
														style={{
															boxShadow:
																'rgb(116 116 116 / 53%) 0px 0px 1px 1px inset',
														}}
														id='residentAllowedVehicles'
														name='residentAllowedVehicles'
														onChange={(e) => onChange(e)}
														list={allowedVehiclesUnits}
														className='addVehicleSelect inputBoxShadow'
													/>
												</div>
												<span
													id='streetParkingSpace'
													className='text-danger danger-msg'
												>
													{residentAllowedVehiclesError &&
														'Please Enter Resident Allowed Vehicles'}
												</span>
											</div>

											<div className='card-info-item card-inner '>
												<div className='label'>
													<p className='mx-3 lable_spacing'>Zone</p>
												</div>
												<div className='data'>
													<input
														type='text'
														className='form-control addVehicleSelect'
														autoComplete='off'
														name='zone'
														onChange={(e) => {
															onChange(e);
														}}
														style={styles.inputStyles}
													/>
												</div>
											</div>

											<div className='card-info-item card-inner'>
												<div className='label'>
													<p className='mx-3 lable_spacing'>
														# of Guest Spaces Allowed{' '}
														<span className='text-danger'>*</span>
													</p>
												</div>
												<div className='data'>
													<Select
														ariaLabel='Default select example'
														placeholder=' '
														style={{
															boxShadow:
																'rgb(116 116 116 / 53%) 0px 0px 1px 1px inset',
														}}
														id='guestAllowedVehicles'
														name='guestAllowedVehicles'
														onChange={(e) => onChange(e)}
														list={allowedVehiclesUnits}
														className='addVehicleSelect inputBoxShadow'
													/>
												</div>
												<span
													id='guestAllowedVehicles'
													className='text-danger danger-msg'
												>
													{guestAllowedVehicleError &&
														'Please Enter Guest Allowed Vehicles'}
												</span>
											</div>

											<div className='card-info-item card-inner'>
												<div className='label'>
													<p className='mx-3 lable_spacing'>
														Maximum Guest Access Duration
														<span className='text-danger'>*</span>
													</p>
												</div>
												<div className='surcharge_box'>
													<input
														type='text'
														value={formData?.guestAccessDuration}
														className='number_field addVehicleSelect'
														autoComplete='off'
														onChange={(e) => {
															onChange(e);
														}}
														name='guestAccessDuration'
														style={styles?.inputStyles}
													/>
													<hr className='surcharge-seprator'></hr>
													<Select
														ariaLabel='Default select example'
														placeholder=' '
														style={{
															boxShadow:
																'rgb(116 116 116 / 53%) 0px 0px 1px 1px inset',
														}}
														value={formData?.guestAccessDurationType}
														id='guestAccessDurationType'
														name='guestAccessDurationType'
														onChange={(e) => onChange(e)}
														list={durationType}
														className='dropdown_field surcharge_daily'
													/>
												</div>
												<span
													id='guestAccessDuration'
													className='text-danger danger-msg'
												>
													{guestAccessDurationError &&
														'Please Enter Duration.'}
												</span>
											</div>
										</div>
									</div>
								</div>
								<Button className='mx-2 mt-3' color='dark' onClick={createUnit}>
									Save
								</Button>
								<Button
									className='mt-3'
									color='danger'
									onClick={() => navigate('/Unit')}
								>
									Cancel
								</Button>
							</CardBody>
						</Card>
					</div>
				</div>
			</Page>
		</PageWrapper>
	);
};

const styles = {
	dateInput: {
		boxShadow: 'rgb(116 116 116 / 53%) 0px 0px 1px 1px inset',
		lineHeight: '1.5',
		padding: '0.5rem 3rem 0.5rem 1rem',
		height: '3.5rem',
		color: 'transparent',
	},
	onChangeColor: '#323232',
	inputStyles: {
		boxShadow: 'rgb(116 116 116 / 53%) 0px 0px 1px 1px inset',
		lineHeight: '1.5',
		padding: '0.5rem 3rem 0.5rem 1rem',
		height: '3.5rem',
	},
};

export default AddUnit;
